import { getRequestEvaluations } from 'lib/api/decisionEngine';
import AlertBanner from 'lib/designSystem/AlertBanner';
import React from 'react';
import { useDispatch } from 'react-redux';

const getStatusConfig = (status?: string) => {
  switch (status) {
    case 'Rechazado':
      return {
        severity: 'error' as const,
        title: 'Garantía Rechazada',
        message:
          'La ultima evaluación de riesgo de la garantía ha sido rechazada.',
      };
    case 'Aprobado':
      return {
        severity: 'success' as const,
        title: 'Garantía Aprobada',
        message:
          'La ultima evaluación de riesgo de la garantía ha sido aprobada.',
      };
    default:
      return {
        severity: 'info' as const,
        title: 'Garantía en Comite',
        message: 'La garantía se encuentra en el comite de riesgo.',
      };
  }
};

const EvaluationWarning: React.FC<{ id: number }> = ({ id }) => {
  const dispatch = useDispatch();
  const { data, isPending } = getRequestEvaluations(dispatch, {
    requestId: id,
    requestType: 'sgr-warranty-request',
  });

  const finalEvaluation = data?.default?.sort(
    (a, b) => b.createdAt - a.createdAt,
  )[0];
  const finalStatus = finalEvaluation?.statusNode.name;
  const { severity, title, message } = getStatusConfig(finalStatus);

  if (!finalEvaluation || isPending) return null;

  return <AlertBanner severity={severity} title={title} message={message} />;
};

export default EvaluationWarning;
